import React from 'react';

import { BadgeWrapper } from './styles';

export const Badge = ({ quantity }) => (
  <BadgeWrapper>
    <span className="lowercase">{quantity}x</span>
  </BadgeWrapper>
);
